<script>
  import { onDestroy, onMount, tick } from "svelte"
  import DialogBase2 from "../../../../../components/dialog/DialogBase2.svelte";
  import DialogTitle from "../../../../../components/dialog/DialogTitle.svelte";
  import DialogSplitter from "../../../../../components/dialog/DialogSplitter.svelte";
  import DialogContent from "../../../../../components/dialog/DialogContent.svelte";
  import DialogBottomControls from "../../../../../components/dialog/DialogBottomControls.svelte";
  import DialogBottomControlButton from "../../../../../components/dialog/DialogBottomControlButton.svelte";
  import RadioGroup from "../../../../../components/input/RadioGroup.svelte";
  import ParameterNumberInput from "./ParameterNumberInput.svelte";
  import ParameterDateInput from "./ParameterDateInput.svelte";
  import Checkbox2 from "../../../../../components/input/Checkbox2.svelte";

  export let onClose

  export let onSave

  export let itemParameters

  let itemParametersInEdit = structuredClone(itemParameters)

  let dialog = null

  function onClickOk() {
    function sortedJsonStringify(val) {
      return JSON.stringify(val, (_, v) => {
        if (!(v instanceof Object) || v instanceof Array) return v
        return Object.keys(v)
          .sort()
          .reduce((acc, key) => {
            acc[key] = v[key]
            return acc
          }, {})
      })
    }

    // deeply compare the original and the edited, and if they are identical, do not call onSave()
    if (sortedJsonStringify(itemParameters) === sortedJsonStringify(itemParametersInEdit)) return onClose()
    console.debug("itemParameters were edited.")
    onSave(itemParametersInEdit)
  }

  let tempProductionAllowedDaysOfWeek = function(){
    const arr = itemParametersInEdit.productionAllowedDaysOfWeek?.split(";") ?? []
    return {
      monday: arr.includes("1"),
      tuesday: arr.includes("2"),
      wednesday: arr.includes("3"),
      thursday: arr.includes("4"),
      friday: arr.includes("5"),
      saturday: arr.includes("6"),
      sunday: arr.includes("7"),
    }
  }()
  $: itemParametersInEdit.productionAllowedDaysOfWeek = Object.keys(tempProductionAllowedDaysOfWeek)
    .map((d, i) => [d, i + 1])
    .filter(arr => tempProductionAllowedDaysOfWeek[arr[0]])
    .map(arr => arr[1])
    .join(";")

  onMount(async () => {
    await tick()
    dialog.showModal()
  })
  onDestroy(() => dialog.close())
</script>

<DialogBase2 bind:dialog={dialog} onClose={onClose} width="750px">
  <DialogTitle>
    パラメータを編集する
  </DialogTitle>
  <DialogSplitter />
  <DialogContent>
    <p>{itemParametersInEdit.itemCode} に対する平準化パラメタを設定します。</p>
    <div class="parameters-section">
      <div class="parameters-section-title full-row">Max在庫の制約</div>
      <div class="parameter full-row">
        Max在庫制約を厳守する:
        <RadioGroup
          bind:value={itemParametersInEdit.inventoryMaxEnforcementPolicy}
          options={[
            {value: "1", text: "厳守する"},
            {value: "0", text: "可能な限り遵守する"},
          ]}
        />
      </div>
      <div class="parameter">
        Max在庫数量:
        <ParameterNumberInput
          bind:value={itemParametersInEdit.inventoryMaxByQuantity}
        />
      </div>
      <div class="parameter">
        Max在庫日数:
        <ParameterNumberInput
          bind:value={itemParametersInEdit.inventoryMaxByDaysInInventory}
        />
      </div>
    </div>
    <div class="parameters-section">
      <div class="parameters-section-title full-row">
        Min在庫の制約
      </div>
      <div class="parameter">
        Min在庫数量:
        <ParameterNumberInput
          bind:value={itemParametersInEdit.inventoryMinByQuantity}
        />
      </div>
      <div class="parameter">
        Min在庫日数:
        <ParameterNumberInput
          bind:value={itemParametersInEdit.inventoryMinByDaysInInventory}
        />
      </div>
    </div>
    <div class="parameters-section">
      <div class="parameters-section-title full-row">製造ロットサイズ</div>
      <div class="parameter">
        製造ロットサイズUnit:
        <ParameterNumberInput
          bind:value={itemParametersInEdit.manufacturingOrderQuantityUnit}
        />
      </div>
      <div class="parameter">
        最小ロットサイズUnit:
        <ParameterNumberInput
          bind:value={itemParametersInEdit.manufacturingOrderQuantityMin}
        />
      </div>
      <div class="parameter">
        ロット在庫有:
        <RadioGroup
          bind:value={itemParametersInEdit.allowInventoryMaxViolationWhenManufacturingInLots}
          options={[
            {value: "1", text: "許容する"},
            {value: "0", text: "許容しない"},
          ]}
        />
      </div>
    </div>
    <div class="parameters-section">
      <div class="parameters-section-title full-row">日時設定</div>
      <div class="parameter">
        補充開始日:
        <ParameterDateInput
          bind:value={itemParametersInEdit.solverStartDate}
        />
      </div>
      <div class="parameter full-row">
        生産可能曜日:
        <div style="display: inline-flex; gap: .5rem">
          <Checkbox2 label="月" bind:checked={tempProductionAllowedDaysOfWeek.monday} />
          <Checkbox2 label="火" bind:checked={tempProductionAllowedDaysOfWeek.tuesday}/>
          <Checkbox2 label="水" bind:checked={tempProductionAllowedDaysOfWeek.wednesday}/>
          <Checkbox2 label="木" bind:checked={tempProductionAllowedDaysOfWeek.thursday}/>
          <Checkbox2 label="金" bind:checked={tempProductionAllowedDaysOfWeek.friday}/>
          <Checkbox2 label="土" bind:checked={tempProductionAllowedDaysOfWeek.saturday}/>
          <Checkbox2 label="日" bind:checked={tempProductionAllowedDaysOfWeek.sunday}/>
        </div>
      </div>
    </div>
  </DialogContent>
  <DialogSplitter />
  <DialogBottomControls>
    <DialogBottomControlButton onClick={onClickOk}>
      OK
    </DialogBottomControlButton>
    <DialogBottomControlButton type="secondary" onClick={onClose}>
      キャンセル
    </DialogBottomControlButton>
  </DialogBottomControls>
</DialogBase2>

<style>
  .parameters-section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    padding: .5rem
  }
  .parameters-section-title {
    font-weight: bold;
  }
  .parameter {
    display: flex;
    gap: .5rem;
    align-items: center;
  }
  .full-row {
    grid-column-start: 1;
    grid-column-end: 3;
  }
</style>
